import styled from 'styled-components';
import { CalanderIcon } from '../../../components/icon/icon';
import { todayDate } from '../../../utils/util';
import { NoticeSection } from '../../../components/user/home/user.home.,section.notice';
import { UserMainSection } from '../../../components/user/home/user.home.section';
import { OrderSection } from '../../../components/user/home/user.home.section.order';
import { useSetRecoilState } from 'recoil';
import { vehicleState } from '../../../atoms/vehicleState';
import { useEffect, useState } from 'react';
import { fetchDriverMypage } from '../../../api/mypage';
import { fetchDriverHomeData } from '../../../api/home';

const testData = {
  workingType: '전일',
  companyName: '공주 우진',
  arrivalTime: '10시 30분',
  dayPrice: 700000,
  monthPrice: 3500000,
};

const fakeDate = [
  {
    companyName: '공주 우진',
    count: 3,
  },
  {
    companyName: '청주 한일',
    count: 2,
  },
  {
    companyName: '부강 주안',
    count: 2,
  },
  {
    companyName: '세종 금창',
    count: 1,
  },
  {
    companyName: '공주 우진',
    count: 3,
  },
];

const fakeData2 = [
  {
    title: '시스템 정기 점검 안내',
    date: '2024-06-22',
  },
  {
    title: '시스템 점건 안내',
    date: '2024-06-21',
  },
  {
    title: '시스템 오픈 안내',
    date: '2024-06-20',
  },
];

// 개별 데이터 타입 정의
interface DriverScheduleDto {
  work: string; // 작업 형태
  target: string; // 도착 시
  amount: number; // 금액
  name: string; // 기업명
}

interface DriverOrderDto {
  name: string; // 기업명
  orderCount: number; // 발주 건수
}

interface CommonNoticeDto {
  title: string; // 공지 제목
  createdAt: string; // 공지 날짜
}

// 상위 데이터 타입 정의
interface DriverHomeDto {
  schedules: DriverScheduleDto[]; // 작업 스케줄 리스트
  orderCounts: DriverOrderDto[]; // 발주 건수 리스트
  notices: CommonNoticeDto[]; // 공지 리스트
  monthlyAmount: number; // 이번 달 매출 합계
}

const UserHome = () => {
  const setVehicleState = useSetRecoilState(vehicleState); // Recoil 상태 업데이트 함수
  const [data, setData] = useState<DriverHomeDto>();
  const today = todayDate();

  // 마이페이지 데이터 가져오기
  useEffect(() => {
    const fetchData = async () => {
      try {
        const driverData = await fetchDriverMypage();
        setVehicleState(driverData.vehicle);
      } catch (error) {
        console.error('마이페이지 데이터를 불러오는 데 실패했습니다.');
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const getHomeData = async () => {
      const response = await fetchDriverHomeData();
      setData(response);
    };

    getHomeData();
  }, []);

  return (
    <Container>
      <section className="date">
        <span className="icon-box">
          <CalanderIcon />
        </span>
        <span className="today">{today}</span>
      </section>
      <UserMainSection
        schedules={data?.schedules}
        monthlyAmount={data?.monthlyAmount}
      />
      <OrderSection orders={data?.orderCounts || []} />
      <NoticeSection notice={data?.notices || []} />
    </Container>
  );
};

export default UserHome;

//style
const Container = styled.div`
  padding: 0 1.5rem;
  .date {
    display: flex;
    gap: 0.7rem;
    padding: 1.1rem 0;
    .icon-box {
      display: flex;
    }
    .today {
      font-size: 1.2rem;
      font-weight: 600;
      line-height: 1.5rem;
    }
  }
`;
